let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hgIdF")).then(() => parcelRequire('d6Jww'));